import React, { useState } from 'react'
import { connect, useSelector } from 'react-redux'

import styled from 'styled-components'
import Pagination from 'react-responsive-pagination'

import { P } from '../../../style/Typography.style'

import TalentCard from './TalentCard'
import TalentControls from '../../../pages/dashboard/talent-pool/components/TalentControls'
import EditApplicantDetails from '../../../pages/dashboard/requisitions/components/EditApplicantDetails'
import Loader from '../../Loader'

import { filterTalents } from '../../../store/actions/talentActions'

const TalentLists = ({
  showDetails,
  setShowDetails,
  isLoading,
  filterTalents,
}) => {
  const [active, setActive] = useState('')

  const talents = useSelector((state) => state.talents.talents)
  const { modal } = useSelector((state) => state.lists)

  const pagination = useSelector((state) => state.talents.pagination)

  const handlePageChange = (pageNumber) => {
    filterTalents(pageNumber)
  }

  return (
    <StyledTalentLists>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <TalentControls />

          {talents && talents.length > 0 ? (
            <>
              {talents.map((talent, index) => (
                <TalentCard
                  setShowDetails={setShowDetails}
                  showDetails={showDetails}
                  talent={talent}
                  setActive={setActive}
                  active={active}
                  key={talent?.email || index}
                  index={index}
                />
              ))}
              <Pagination
                total={pagination?.pageCount || 1}
                current={pagination?.page || 1}
                onPageChange={(page) => handlePageChange(page, pagination)}
              />

              {modal.includes('editApplicantDetails') && (
                <EditApplicantDetails />
              )}
            </>
          ) : (
            <P size=".75rem">No applicants found</P>
          )}
        </>
      )}
    </StyledTalentLists>
  )
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.talents.isLoading,
  }
}

export default connect(mapStateToProps, {
  filterTalents,
})(TalentLists)

const StyledTalentLists = styled.div`
  width: 100%;
  max-width: 30.25rem;
  height: 100%;
  margin-top: 1rem;
  padding-bottom: 6rem;
  box-sizing: border-box;
`
